import API from '../../component/Axios'

export const ONBOARDING_FUNNEL_SUMMARY_PATH = '/api/v1/admin/analytics/onboarding-funnel/summary'
export const ONBOARDING_FUNNEL_STEPS_PATH = '/api/v1/admin/analytics/onboarding-funnel/steps'

const normalizeString = value => (
    typeof value === 'string' ? value.trim() : ''
)

const isRecord = value => (
    value !== null && typeof value === 'object' && !Array.isArray(value)
)

const validateResponseEnvelope = (data, { requireFilter = false } = {}) => {
    if (!isRecord(data)
        || !isRecord(data.meta)
        || !Array.isArray(data.days)
        || (requireFilter && !isRecord(data.filter))) {
        throw new Error('온보딩 퍼널 응답 형식이 올바르지 않습니다.')
    }

    return data
}

export const buildOnboardingFunnelSummaryParams = ({
    from,
    to,
    platform = 'ALL',
} = {}) => ({
    from: normalizeString(from),
    to: normalizeString(to),
    platform: normalizeString(platform || 'ALL').toUpperCase(),
})

export const buildOnboardingFunnelStepsParams = ({
    from,
    to,
    platform = 'ALL',
    marketType,
    authType,
    method,
    countryCode = 'ALL',
} = {}) => {
    const normalizedMethod = normalizeString(method).toLowerCase()
    const params = {
        from: normalizeString(from),
        to: normalizeString(to),
        platform: normalizeString(platform || 'ALL').toUpperCase(),
        marketType: normalizeString(marketType).toLowerCase(),
        authType: normalizeString(authType).toLowerCase(),
        countryCode: normalizeString(countryCode || 'ALL').toUpperCase(),
    }

    if (normalizedMethod && normalizedMethod !== 'all') {
        params.method = normalizedMethod
    }

    return params
}

export const getOnboardingFunnelSummary = async (query) => {
    const { data } = await API.get(ONBOARDING_FUNNEL_SUMMARY_PATH, {
        params: buildOnboardingFunnelSummaryParams(query),
    })

    return validateResponseEnvelope(data)
}

export const getOnboardingFunnelSteps = async (query) => {
    const { data } = await API.get(ONBOARDING_FUNNEL_STEPS_PATH, {
        params: buildOnboardingFunnelStepsParams(query),
    })

    return validateResponseEnvelope(data, { requireFilter: true })
}
